module.exports = "<svg id=\"173600db-ec73-45be-bda6-32fab6dc46fa\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.18 36\"><title>ContactArrow</title><g id=\"bfd57d99-1b0c-4e97-a31d-0b5d91de23a4\" data-name=\"Mockup-V2.0\"><g id=\"fd96e372-4bdb-4755-8846-64768a7c7174\" data-name=\"V3\"><path id=\"4aad5a7a-e30c-4cf2-9cb4-2061c913746a\" data-name=\"Fill-1\" d=\"M0,0,31.18,18,0,36Z\" style=\"fill:#dcdcdc\"></path></g></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ContactArrow.svg
// module id = MQuI
// module chunks = 2